export default __webpack_public_path__ + "static/media/logo-proventa.9ce27c18.svg";